import React from 'react';

/**
 * HumaTwin Master Brand Logo Component
 * 
 * The symbol represents:
 * - Left structure: Real Entity (individual, organization, or state)
 * - Right structure: Digital Twin (the living digital representation)
 * - Central vertical: Connection, Intelligence, and Continuous Sync
 * - Negative space forms the letter "H"
 * 
 * This is the MASTER brand symbol shared across:
 * - HumaTwin Personal
 * - HumaTwin Enterprise  
 * - HumaTwin State
 */

export function HumaTwinIcon({ size = 48, className = '' }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="HumaTwin"
    >
      {/* Left bracket - Real Entity (Teal) */}
      <path
        d="M15 50C15 30 25 15 40 15L40 25C30 25 25 35 25 50C25 65 30 75 40 75L40 85C25 85 15 70 15 50Z"
        fill="url(#tealGradient)"
      />
      
      {/* Right bracket - Digital Twin (Blue) */}
      <path
        d="M85 50C85 30 75 15 60 15L60 25C70 25 75 35 75 50C75 65 70 75 60 75L60 85C75 85 85 70 85 50Z"
        fill="url(#blueGradient)"
      />
      
      {/* Central intelligence/data connection */}
      <line x1="50" y1="20" x2="50" y2="80" stroke="url(#connectionGradient)" strokeWidth="2" />
      
      {/* Connection nodes */}
      <circle cx="50" cy="25" r="4" fill="#00B4A6" />
      <circle cx="50" cy="40" r="3" fill="#2ABFB3" />
      <circle cx="50" cy="50" r="5" fill="#3AC4C0" />
      <circle cx="50" cy="60" r="3" fill="#4A9FD4" />
      <circle cx="50" cy="75" r="4" fill="#4A6CF7" />
      
      {/* Gradients */}
      <defs>
        <linearGradient id="tealGradient" x1="15" y1="15" x2="40" y2="85" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#00B4A6" />
          <stop offset="100%" stopColor="#00D4C4" />
        </linearGradient>
        <linearGradient id="blueGradient" x1="60" y1="15" x2="85" y2="85" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#4A6CF7" />
          <stop offset="100%" stopColor="#6B8AFF" />
        </linearGradient>
        <linearGradient id="connectionGradient" x1="50" y1="20" x2="50" y2="80" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#00B4A6" />
          <stop offset="100%" stopColor="#4A6CF7" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function HumaTwinLogoFull({ size = 48, showText = true, className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <HumaTwinIcon size={size} />
      {showText && (
        <span className="font-heading font-bold text-gray-900" style={{ fontSize: size * 0.5 }}>
          HumaTwin
        </span>
      )}
    </div>
  );
}

export default HumaTwinIcon;
